
import React, { useEffect, useState } from 'react';
import DeviceDisplay from './DeviceDisplay';
import Footer from './Footer';
import LoginForm from './LoginForm';
import { service } from "../services/service";
import md5 from "md5";
import './Login.css';
import Pagination from './Pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Snackbar } from '@mui/material';

const LoginPage = () => {

  const modulesInfo = [
    {
      title: "Inventory Management",
      tagline: "Optimize inventory with smart material tracking, seamless reconciliation, and AI-driven demand forecasting."
    },
    {
      title: "Smart HRMS",
      tagline: "Streamline hiring, attendance, payroll, and performance with an intelligent, people-first platform."
    },
    {
      title: "Plant & Machinery",
      tagline: "Maximize equipment efficiency with real-time tracking, smart maintenance scheduling, and asset lifecycle insights."
    },
    {
      title: "Integrated Planning & Billing",
      tagline: "Drive project success with precise planning, automated billing, and seamless cost control — all in one platform."
    },
    {
      title: "Accounts",
      tagline: "Simplify financial operations with accurate bookkeeping, real-time insights, and seamless compliance tracking."
    }
  ]
  const [password, setPassword] = useState('');
  const [selectedModuleSlide, setSelectedModuleSlide] = useState(0)

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null)
  const [vertical, setVertical] = useState("bottom")
  const [horizontal, setHorizontal] = useState("right")
  const [loginAttempt, setLoginAttempt] = useState(false)
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState();
  const [companyToken, setCompanyToken] = useState("");
  const [companyName, setCompanyName] = useState('')
  const [companyLogo, setCompanyLogo] = useState('')
  const [openForgotPassword, setForgotPassword] = useState(false)
  const [forgottenPassword, setForgottenPassword] = useState("")

  const [loginUrl, setLoginUrl] = useState("")
  const location = useLocation()
  const [loader, setLoader] = useState(false)
  const [signInProcess,setSignInProcess]=useState(false)


  //  Function to close alert
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  //  Function to change the module slide by click
  const handleChangeModuleSlide = (value) => {
    setSelectedModuleSlide(value)
  }

  //   function to handle login
  const navigateToModules = async (e) => {
    const payload = {
      companyToken: companyToken,
      password: md5(password || ""),
      username: user || ""
    }
    setSignInProcess(true)
    await service.authenticate(payload).then((response) => {
      if (response?.status === 200) {
        if (response?.data?.token) {

          navigate(`/modulesSelection?token=${response?.data?.token}`, { state: { loginUrl: window.location.href, logo: companyLogo } })
          localStorage.setItem("userName", response?.data?.firstName)
          localStorage.setItem("companyToken", response?.data?.token)

        }

        setLoginAttempt(response?.data?.status === 200 ? true : false)
        setOpen(true)
        if (response?.data?.status !== 200) {
          setLoginAttempt(false)
          setErrorMessage({ status: response?.data?.status, msg: response?.data?.message || "Something went wrong!" })

        }

      } else {

        setOpen(true)
        setLoginAttempt(false)
        setErrorMessage({ status: response?.status, msg: response?.message || "Un-Authorised" })

      }
    }).catch((error) => console.log(error))
    .finally(()=> { setSignInProcess(false)})

  }



//    function to get intial company info from url
  const getInitalInfo = async (forNck) => {
    const pathArray = location.pathname.split('/');
    const companyIdentifier = pathArray[1];

    if (forNck === "HardCodedForNKC") {
      setCompanyLogo("https://nyggs-bucket.s3.ap-south-1.amazonaws.com/1695796119595_NKC%20side%20menu.png");
      setCompanyName("NKC PROJECTS PVT. LTD.");
      setCompanyToken("FDGVB@^&2");
    } else {
      const apiEndpoint = "employee/whiteListed/v2/getCompanyConfigV2";

      setLoginUrl(window.location.href);

      const res = await service.get(apiEndpoint);  // Use async/await for clarity
      const { data } = res;

      if (data?.data) {
        const { headerLogo, companyName, companyToken } = data.data;

        setCompanyLogo(headerLogo);
        setCompanyName(companyName.toUpperCase());
        setCompanyToken(companyToken);
        console.log("Company Token:", companyToken);
      } else {
        console.error("Invalid data response", res);
      }
    }
  };


  useEffect(() => {
    // Store current origin for reuse
    const currentOrigin = window.location.origin;

    // Check if the currentOrigin starts with the specified domain
    const configType = currentOrigin.startsWith("https://nkcsso.nyggs.com") ? "HardCodedForNKC" : "Normal";
    getInitalInfo(configType);

    setLoader(true)
    setTimeout(() => {
      setLoader(false)
    }, 1500);

  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedModuleSlide(prevIndex => (prevIndex + 1) % modulesInfo.length);
    }, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <>
    
    <div className="login-page">
      <div className="login-container">
        <div className="info-section">
          <div className="info-content" key={selectedModuleSlide}>
            <h1>{modulesInfo[selectedModuleSlide]?.title || ""}</h1>
            <p>
              {modulesInfo[selectedModuleSlide]?.tagline || ""}
            </p>

            <DeviceDisplay />
            <Pagination
              selectedModuleSlide={selectedModuleSlide}
              modulesInfo={modulesInfo}
              handleChangeModuleSlide={handleChangeModuleSlide}
            />
          </div>
        </div>

        <div className="login-section">
          <div className="login-card">
            {/* <NyggsLogo /> */}
            <div className='logo-container'>
              <img src={companyLogo || ""} alt='Logo' />

            </div>
            <div className="divider">
              <span>Sign in to access NYGGS</span>
            </div>
            <LoginForm
              companyLogo={companyLogo} setPassword={setPassword} setUser={setUser} password={password} user={user} navigateToModules={navigateToModules}
              signInProcess={signInProcess}
            />
          </div>

          <Footer />
        </div>
      </div>
    </div>
    <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={`${loginAttempt ? "success" : "error"}`} sx={{ width: '100%' }}>
          {loginAttempt ? "Login Success" : errorMessage?.msg?.length > 0 ? errorMessage?.msg : "Employee Code or Password is wrong !"}
        </Alert>
      </Snackbar>
    </>
  
  );
};

export default LoginPage;